export default "__VITE_ASSET__88abb8b2__"